import { gql } from '@apollo/client';
import fragments from './fragments';

export const ASSET_HIERARCHY_LIST_QUERY = gql`
  query assetHierarchies($pager: PagerInputNew!, $filters: AssetHierarchyFilterInput) {
    assetHierarchies(pager: $pager, filters: $filters) {
      total
      values {
        id
        name
        assetType
        provider
      }
    }
  }
`;

export const TYPE_ASSET_HIERARCHY_LIST_QUERY = gql`
  query assetHierarchiesType($pager: PagerInputNew!, $filters: AssetHierarchyFilterInput) {
    assetHierarchiesType(pager: $pager, filters: $filters) {
      total
      values {
        id
        name
        imageUrl
      }
    }
  }
`;

export const ASSET_HIERARCHY_LIST_MAIN_FILTERS_CLIENT_QUERY = gql`
  {
    assetHierarchyFiltersMain @client {
      fullTextFilter {
        value
        label
      }
      hierarchyProvider {
        value
        label
      }
      assetType {
        value
        label
      }
      hierarchy {
        value {
          ...assetHierarchyLevel
        }
        label
      }
    }
  }
  ${fragments.assetHierarchyLevel}
`;

export const ASSET_HIERARCHY_LIST_MINOR_FILTERS_CLIENT_QUERY = gql`
  {
    assetHierarchyFiltersMinor @client {
      fullTextFilter {
        value
        label
      }
      hierarchyProvider {
        value
        label
      }
      assetType {
        value
        label
      }
      hierarchy {
        value {
          ...assetHierarchyLevel
        }
        label
      }
    }
  }
  ${fragments.assetHierarchyLevel}
`;

export const ASSET_TYPES_QUERY = gql`
  query assetHierarchyTypes {
    assetHierarchyTypes {
      ...assetHierarchy
    }
  }
  ${fragments.assetHierarchy}
`;

export const ASSET_HIERARCHY_QUERY = gql`
  query assetHierarchy($assetTypeId: Int) {
    assetHierarchy(assetTypeId: $assetTypeId) {
      ...assetHierarchyLevel
    }
  }
  ${fragments.assetHierarchyLevel}
`;

export const ASSET_HIERARCHY_LEVEL_SOURCE_QUERY = gql`
  query assetHierarchyLevelSource($parentId: Int!) {
    assetHierarchyLevelSource(parentId: $parentId) {
      level
      data {
        id
        code
        name
        itemId
        imageUrl
        reverseLevel
      }
    }
  }
`;

export const ASSET_HIERARCHY_DATA_QUERY = gql`
  query assetHierarchyData($hierarchyId: Int!) {
    assetHierarchyData(hierarchyId: $hierarchyId) {
      id
      name
      active
      uniqueIdentifier
      validFrom
      validTo
      listPrice
      imageUrl
      itemCode
      itemName
      source
      currencyCode
    }
  }
`;

export const ASSET_HIERARCHY_SOURCES_QUERY = gql`
  query assetHierarchySources {
    assetHierarchySources {
      name
      displayName
    }
  }
`;
